// Phase 91: one place to decide "is this placement on a sleeve?".
// Used by the standalone sleeve emoji picker (PlacementSection), the
// preview (PreviewCanvas), spot-completion logic, and the sleeve name
// cross-sell. Keeping it shared avoids the three slightly-different
// copies that existed before (a SLEEVE_SLUGS set in one file, a
// `/sleeve|arm/i` regex in another).

// Known sleeve placement slugs. The seeded placements on this shop use
// the short form (`l-sleeve`), but long/underscore variants are matched
// too. Lookup is case-insensitive.
export const SLEEVE_SLUGS = new Set([
  "sleeve",
  "left-sleeve",
  "right-sleeve",
  "l-sleeve",
  "r-sleeve",
  "left_sleeve",
  "right_sleeve",
]);

/** True when a placement slug sits on a sleeve. Matches the known slug
 *  set first, then falls back to a loose "sleeve"/"arm" word match so a
 *  custom slug like `upper-arm` still counts. */
export function isSleeveSlug(slug: string | null | undefined): boolean {
  if (!slug) return false;
  const s = slug.toLowerCase();
  if (SLEEVE_SLUGS.has(s)) return true;
  return /(^|[-_])(sleeve|arm)([-_]|$)/.test(s);
}

/** True when an upsell kind is one of the sleeve emoji motifs. */
export function isSleeveEmojiKind(kind: string | null | undefined): boolean {
  return !!kind && kind.startsWith("sleeve_emoji_");
}
